import { LinkButton, LinkButtonProps } from 'fronton-react';
import { WithGAButtonClickProps, withGAClickButton } from 'common/hocs/with-ga-click-button';
import { Button, ButtonProps } from './button';

export * from './button';
export type ButtonWithGAClickButtonProps = ButtonProps & WithGAButtonClickProps;
export const ButtonWithGAClickButton = withGAClickButton<ButtonWithGAClickButtonProps>(Button);

export type LinkButtonWithGAClickButtonProps = LinkButtonProps & WithGAButtonClickProps;
export const LinkButtonWithGAClickButton = withGAClickButton<LinkButtonWithGAClickButtonProps>(LinkButton);
